import {QueryStatus} from '@reduxjs/toolkit/dist/query'
import {createSelector} from 'reselect'

import {getBovioApiKey} from '@vio/core/src/experiments/modules/selectors'
import {paymentSettingsApi} from '@vio/core/src/offer/services/paymentSettingsApi'
import {
  PaymentSettingsIdType,
  PaymentSettingsRequest
} from '@vio/core/src/offer/types/paymentSettings'
import {buildPaymentSettingsEndpoint} from '@vio/core/src/offer/utils/paymentSettings'

import {getUserCountryCode} from '../meta/selectors'

import type {RootState} from '../../store'
import type {
  Card,
  PaymentMethodType
} from '@vio/core/src/api-types/bovio/response/payment_methods_settings'

const getStateParam = (state: RootState) => state
const getIdParam = (_: RootState, id: string) => id
const getIdTypeParam = (
  _: RootState,
  __: string,
  idType: PaymentSettingsIdType
) => idType

export const getPaymentSettingsParams = createSelector(
  [getIdParam, getIdTypeParam, getUserCountryCode, getBovioApiKey],
  (id, idType, userCountry, profileKey): PaymentSettingsRequest => {
    return {
      url: buildPaymentSettingsEndpoint({
        id,
        idType,
        userCountry,
        baseUrl: process.env.NEXT_PUBLIC_BOVIO_ENDPOINT
      }),
      profileKey,
      clientUserAgent: `accommodation/${process.env.NEXT_PUBLIC_APP_VERSION}`
    }
  }
)
const getPaymentSettingsSelector = createSelector(
  [getPaymentSettingsParams],
  params => paymentSettingsApi.endpoints.getPaymentSettings.select(params)
)

const getPaymentSettingsResult = createSelector(
  [getStateParam, getPaymentSettingsSelector],
  (state: RootState, paymentSettingsSelector) => paymentSettingsSelector(state)
)
export const getSupportedCards = createSelector(
  [getPaymentSettingsResult],
  ({data}): Card[] =>
    data?.paymentMethods?.flatMap(method => method.cards) || []
)
export const getAvailablePaymentMethods = createSelector(
  [getPaymentSettingsResult],
  ({data}): PaymentMethodType[] =>
    data?.paymentMethods?.map(method => method.type) || []
)
export const getIsPaymentSettingsComplete = createSelector(
  [getPaymentSettingsResult],
  ({status, isError}): boolean => status === QueryStatus.fulfilled && !isError
)
export const getPaymentSettings = createSelector(
  [getSupportedCards, getAvailablePaymentMethods, getIsPaymentSettingsComplete],
  (supportedCards, availablePaymentMethods, isComplete) => ({
    supportedCards,
    availablePaymentMethods,
    isComplete
  })
)
